// Fotografia aleasă se micșorează în browser înainte de trimitere: pătrat din mijloc, cel mult 512×512, JPEG.
// Așa intră sub limita de 1 MB (și a nginx-ului) chiar și pozele mari de pe telefon; serverul o redesenează oricum.

export const AVATAR_UPLOAD_SIDE = 512;
export const ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/webp"];

/** Pătratul din mijloc al unei imagini w×h: { sx, sy, side }. */
export function centerSquare(w, h) {
   const side = Math.min(w, h);
   return { sx: Math.round((w - side) / 2), sy: Math.round((h - side) / 2), side };
}

async function decode(file) {
   if (typeof createImageBitmap === "function") {
      try {
         return await createImageBitmap(file, { imageOrientation: "from-image" });
      } catch {}
   }
   const url = URL.createObjectURL(file);
   try {
      const img = new Image();
      img.src = url;
      await img.decode();
      return img;
   } finally {
      URL.revokeObjectURL(url);
   }
}

/** File → Blob JPEG ≤ 512×512. Aruncă eroare cu mesaj pentru om dacă nu e o fotografie. */
export async function shrinkPhoto(file) {
   if (!file || !ACCEPTED_TYPES.includes(file.type)) throw new Error("Alege o fotografie JPEG, PNG sau WebP.");
   let image;
   try {
      image = await decode(file);
   } catch {
      throw new Error("Fișierul nu se poate citi ca fotografie.");
   }
   const w = image.width || image.naturalWidth;
   const h = image.height || image.naturalHeight;
   if (!w || !h) throw new Error("Fișierul nu se poate citi ca fotografie.");
   const { sx, sy, side } = centerSquare(w, h);
   const out = Math.min(AVATAR_UPLOAD_SIDE, side);
   const canvas = document.createElement("canvas");
   canvas.width = out;
   canvas.height = out;
   const ctx = canvas.getContext("2d");
   ctx.drawImage(image, sx, sy, side, side, 0, 0, out, out);
   if (typeof image.close === "function") image.close();
   const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.86));
   if (!blob) throw new Error("Nu am putut pregăti fotografia.");
   return blob;
}
